import React from 'react';
import HeadOfAccountsForm from './HeadOfAccountsForm';

const NewHeadOfAccountPage = () => <HeadOfAccountsForm formType="create" />;

export default NewHeadOfAccountPage;
